import { createAction, props } from '@ngrx/store';
import { CertificationDoc } from '../_models/certificationDoc';

// Action types
export const loadCertificationDocs = createAction('[CertificationDoc] Load CertificationDocs');
export const loadCertificationDocsSuccess = createAction(
  '[CertificationDoc] Load CertificationDocs Success',
  props<{ certificationDocs: CertificationDoc[] }>()
);
export const loadCertificationDocsFailure = createAction(
  '[CertificationDoc] Load CertificationDocs Failure',
  props<{ error: any }>()
);

export const addCertificationDoc = createAction(
  '[CertificationDoc] Add CertificationDoc',
  props<{ certificationDoc: CertificationDoc }>()
);
export const addCertificationDocSuccess = createAction(
  '[CertificationDoc] Add CertificationDoc Success',
  props<{ certificationDoc: CertificationDoc }>()
);
export const addCertificationDocFailure = createAction(
  '[CertificationDoc] Add CertificationDoc Failure',
  props<{ error: any }>()
);

export const updateCertificationDoc = createAction(
  '[CertificationDoc] Update CertificationDoc',
  props<{ certificationDoc: CertificationDoc }>()
);
export const updateCertificationDocSuccess = createAction(
  '[CertificationDoc] Update CertificationDoc Success',
  props<{ certificationDoc: CertificationDoc }>()
);
export const updateCertificationDocFailure = createAction(
  '[CertificationDoc] Update CertificationDoc Failure',
  props<{ error: any }>()
);

export const deleteCertificationDoc = createAction(
  '[CertificationDoc] Delete CertificationDoc',
  props<{ id: number }>()
);
export const deleteCertificationDocSuccess = createAction(
  '[CertificationDoc] Delete CertificationDoc Success',
  props<{ id: number }>()
);
export const deleteCertificationDocFailure = createAction(
  '[CertificationDoc] Delete CertificationDoc Failure',
  props<{ error: any }>()
);
